module.exports = __webpack_public_path__ + "img/thumb_21.abd5c096.jpg";